import { render } from "./hover_dropzone.vue?vue&type=template&id=10687cde"
import script from "./hover_dropzone.vue?vue&type=script&lang=js"
export * from "./hover_dropzone.vue?vue&type=script&lang=js"

import exportComponent from "/app/docuseal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__